import { Map as IMap } from 'immutable';

import { sanitizeUrl } from '../utils/urlUtils';
import { isMobileView } from '../utils/mobileUtils';

import programMessages, { optionalProgramMessageIds } from './programMessages';
import { formatProgramMessage } from './formatProgramMessage';



export const getPreferredProgramCode = () => {
    const search = new window.URLSearchParams(window.location.search);
    return search.get('programCode');
};

const findCatalogRange = (catalog) => {
    const minRange = Math.min(
        catalog.getIn(['egcRangedCatalog', 'start'], Infinity),
        catalog.getIn(['plasticRangedCatalog', 'start'], Infinity),
        ...catalog.get('egcFixedCatalog', [Infinity]),
        ...catalog.get('plasticFixedCatalog', [Infinity])
    );
    const maxRange = Math.max(
        catalog.getIn(['egcRangedCatalog', 'end'], 0),
        catalog.getIn(['plasticRangedCatalog', 'end'], 0),
        ...catalog.get('egcFixedCatalog', [0]),
        ...catalog.get('plasticFixedCatalog', [0])
    );
    return { minRange, maxRange };
};

export const generateProgramProps = (group, index, {
    name,
    selectProgram,
    intl,
    classicCardsDescription,
    defaultCurrencyCode,
    classicCatalogs,
    getFaceplateByProgram,
    selectedProgram,
    windowWidth,
    shouldFocus,
    DEFAULT_ELECTRONIC_FACEPLATES,
    DEFAULT_PHYSICAL_FACEPLATES,
    getAltImageByProgram,
    brandCode,
    showCurrencyCode,
    showCurrencyList
}) => {
    const programCode = group.get('programCode');
    const descriptionMessageKey = `${programCode}.${optionalProgramMessageIds.programDescription}`;
    const descriptionExists = !!intl.messages[descriptionMessageKey];
    const description = descriptionExists ? formatProgramMessage(intl,
        { id: descriptionMessageKey }, programCode, { programCode }) : null;
    const text = programCode
        ? formatProgramMessage(intl, programMessages.programTitle, programCode, { programCode })
        : intl.formatMessage(programMessages.classicExperienceTitle);
    const showClassicCardsDescription = Boolean(!programCode && classicCardsDescription);
    
    let previewFaceplate = getFaceplateByProgram(programCode, DEFAULT_ELECTRONIC_FACEPLATES);
    if (previewFaceplate.size <= 0) {
        previewFaceplate = getFaceplateByProgram(programCode, DEFAULT_PHYSICAL_FACEPLATES);
    }
    const catalogs = group.get('catalogs', classicCatalogs);
    const rangeCurrencyCode = catalogs.has(defaultCurrencyCode) ? defaultCurrencyCode : catalogs.keySeq().first();
    const { minRange, maxRange } = findCatalogRange(catalogs.get(rangeCurrencyCode));
    const currencyList = catalogs.keySeq().toList().filter(currencyCode => currencyCode !== rangeCurrencyCode);
    const altImage = getAltImageByProgram(programCode);
    const previewImageFilename = altImage.get('previewImageFilename');
    const previewImageAltText = altImage.get('previewImageAltText');
    return {
        name,
        val: programCode,
        text,
        handleChange: () => selectProgram(programCode),
        description,
        classicCardsDescription,
        showClassicCardsDescription,
        previewFaceplate,
        defaultCurrencyCode,
        rangeCurrencyCode,
        minRange,
        maxRange,
        currencyList,
        showDenomRange: true,
        isChecked: programCode === selectedProgram,
        key: `${name}-${programCode}`,
        windowWidth,
        shouldFocus,
        previewImageAltText,
        previewImageFilename,
        brandCode,
        showCurrencyCode,
        showCurrencyList
    };
};

export const generateSelectProgramBtnProps = ({
    selectedProgram,
    customTileSelected,
    customCardMessages,
    switchProgram,
    submitAction,
    windowWidth,
    intl,
    showValidationWarning
}) => {
    const disableButton = selectedProgram === null && !customTileSelected;
    const nextAction = () => {
        if (customTileSelected) {
            const cleanUrl = sanitizeUrl(customCardMessages.get('customCardActionUrl'));
            window.open(cleanUrl, 'noopener');
        } else {
            switchProgram(selectedProgram);
            submitAction(IMap({ programCode: selectedProgram }));
        }
    };
    return {
        onClick: disableButton
            ? showValidationWarning
            : nextAction,
        btnType: 'button',
        
        
        btnText: customTileSelected
            ? customCardMessages.get('customCardActionButton') || intl.formatMessage(programMessages.buttonText)
            : intl.formatMessage(programMessages.buttonText),
        cashbotName: 'select-program',
        isSticky: !disableButton && isMobileView(windowWidth)
    };
};
